import { render, staticRenderFns } from "./InvInManager.vue?vue&type=template&id=737a618d&scoped=true&"
import script from "./InvInManager.vue?vue&type=script&lang=js&"
export * from "./InvInManager.vue?vue&type=script&lang=js&"
import style0 from "./InvInManager.vue?vue&type=style&index=0&id=737a618d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737a618d",
  null
  
)

export default component.exports